import React, { ReactNode } from "react";
import { LandingProps } from "@/types/Landing";
import styles from "./LandingHero.module.scss";

/**
 * Compact hero with the logo of the paper in front of the title and intro
 */
const LandingHero = ({title, paper, intro, hideLogo, backgroundImage, background, children}: Pick<LandingProps, 'title' | 'paper'> & {
  /**
   * text below the title, next to the logo
   */
  intro: ReactNode
  hideLogo?: boolean
  /**
   * decorative photo behind the hero, fading into the solid background on the left
   */
  backgroundImage?: string
  /**
   * solid color the photo fades into, defaults to --beige
   */
  background?: string
  children?: ReactNode
}) => {
  const hasLogo = !!paper.logo && !hideLogo;

  return <section className={styles.hero} style={background ? {'--hero-background': background} as React.CSSProperties : undefined}>
    {backgroundImage && <div className={styles.backdrop}>
      <img src={backgroundImage} alt="" />
    </div>}
    <div className={`${styles.inner} ${hasLogo ? styles.hasLogo : ''}`}>
      {/* in front of the title on small screens, in front of the title and intro from md */}
      {hasLogo && <div className={styles.logo}>
        <img src={paper.logo!} alt={paper.title} />
      </div>}
      <h1>{title}</h1>
      <div className={styles.intro}>{intro}</div>
      <div className={styles.body}>{children}</div>
    </div>
  </section>;
};

export default LandingHero;
